module.exports = __webpack_public_path__ + "img/2.c7b84455.png";